import { render, staticRenderFns } from "./PackingBatches.vue?vue&type=template&id=3aecf854&scoped=true"
import script from "./PackingBatches.vue?vue&type=script&lang=js"
export * from "./PackingBatches.vue?vue&type=script&lang=js"
import style0 from "./PackingBatches.vue?vue&type=style&index=0&id=3aecf854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aecf854",
  null
  
)

export default component.exports